import styled from "styled-components"

export const ToolbarContainer = styled.div`
  background: ${p => p.theme.colors.white};
  border: 0.1rem solid ${p => p.theme.colors.borderLight};
  padding: 1rem;
  width: 35rem;
`

export const ToolbarButton = styled.button`
  width: 100%;
  display: flex;
  border: 0.1rem solid ${p => p.theme.colors.borderLight};
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1rem;
  padding: 1.3rem 1rem;
  background: ${p => p.theme.colors.white};
  border-radius: 0.6rem;

  div {
    margin-right: 1rem;
  }
`

const Dot = styled.div`
width: 1rem;
  height: 1rem;
  border-radius: 50%;
`

export const ConditionDot = styled(Dot)`
background: ${p => p.theme.colors.workflows.condition};
`

export const ActionDot = styled(Dot)`
background: ${p => p.theme.colors.workflows.action};
`

export const BranchDot = styled(Dot)`
background: ${p => p.theme.colors.workflows.branch};
`

export const Label = styled.div`
color: ${p => p.theme.colors.greyDark};
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  font-weight: 700;
  margin: 1rem 0;
font-size: 1.2rem;
`

export const Divider = styled.div`
height: 0.1rem;
  width: 100%;
  background: ${(p) => p.theme.colors.greyLight};
  margin: 2rem 0;
`
